import { Controller } from "stimulus";
import Swiper, { EffectFade, Navigation, Pagination } from "swiper";

Swiper.use([Pagination, EffectFade, Navigation]);

export default class extends Controller {
  static targets = ["prev", "next", "slider", "pagination"];

  connect() {
    this.initSlider();
  }

  initSlider() {
    this.swiper = new Swiper(this.sliderTarget, {
      slidesPerView: 1,
      centeredSlides: true,
      speed: 800,
      autoHeight: true,
      threshold: 35,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: this.nextTarget,
        prevEl: this.prevTarget,
      },
      pagination: {
        el: this.paginationTarget,
        clickable: true,
      },
      breakpoints: {
        700: {
          threshold: 70,
        },
        1024: {
          threshold: 100,
        },
      },
    });
  }
}
